import { ContentfulTermsConditions } from '@jbhi-fi/apis/src/contentful/types';
import type {
  TermsAndConditionsData,
  TermsAndConditionsSymbol,
} from '../../TermsAndConditions/TermsAndConditionsModal';

export abstract class TermsAndConditionsTransformer {
  static toTermsAndConditions = (entry?: ContentfulTermsConditions): TermsAndConditionsData | undefined => {
    if (!entry?.fields?.mainBody) return undefined;
    return {
      mainBody: entry.fields.mainBody,
      symbol: (entry.fields.termsSymbol as TermsAndConditionsSymbol) ?? undefined,
      linkColor: entry.fields.useWhiteFont ? 'white' : 'black',
    };
  };
}
